// 存储异步方法
import Api, { LoadConfig } from '@/service';
import { getUser } from '@/util/store';
import XSS from '@/util/xss';

// 配置数据
let __userConfig;
export const getUserConfig = () => {
  const { identifier } = getUser();
  if (!__userConfig) {
    const queryConfig = new LoadConfig({
      loadingMsg: $t('链接校验中...'),
    });
    return Api.config({ identifier }, queryConfig).then(res => {
      __userConfig = res.data;
      return __userConfig;
    });
  }

  return Promise.resolve(__userConfig);
};

export const getUserIdValid = () => {
  return getUserConfig().then(config => config.isValidIdentifier);
};

// let __watermarkConf;
// const includeWMCode = {
//   [1]: true, // 水印文案
//   [4]: true, // 当前年月日
// };
// export const getWatermarkConf = () => {
//   if (__watermarkConf) {
//     return Promise.resolve(__watermarkConf);
//   }
//   return Api.getPreviewWatermark().then(res => {
//     // 水印文字字段无值不展示水印
//     const mainMark = res.data.find(d => d.code === 1);
//     if (!mainMark.text) {
//       return __watermarkConf = [];
//     }

//     // 获取规定值并按order排序
//     __watermarkConf = res.data.filter(d => includeWMCode[d.code]).sort((a, b) => a.order - b.order);
//     return __watermarkConf;
//   });
// }
// export const getWatermark = () => {
//   return getWatermarkConf().then(conf => {
//     return conf.map(c => c.text).join(' ');
//   });
// }
let __watermark;
let __globalAlpha;
export const getWatermark = opts => {
  if (__watermark) {
    return Promise.resolve({
      __watermark,
      __globalAlpha,
    });
  }
  let _api = Api.getPreviewWatermarkConfig;
  if (opts && opts.isScrm) {
    _api = Api.cepGetPreviewWatermarkConfig;
  }
  return _api({}, new LoadConfig({
    needError: false,
  })).then(res => {
    __watermark = XSS(res.data.previewWatermark);
    __globalAlpha = res.data.brightness / 100 || 1;
    return {
      __watermark,
      __globalAlpha,
    };
  });
};
